export function getImgUrl(handle, width) {
  const w = width ? Math.round(width) : 400
  return `https://cdn.filestackcontent.com/resize=w:${w}/compress/${handle}`
}
